export const DJS_LIMIT_FULL_VIEW = 3;
